// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2qvK1","itemTitle":"ClientEmergencyInfo_itemTitle__2gFH3","itemText":"ClientEmergencyInfo_itemText__2e8Nc"};